import { FeatureViewed } from '@ria-client/segment/components/FeatureViewed';
import type { PostAuthor } from '@ria-client/supergraph/structuredContent/hydration/FirstPersonPerspectiveItem/schema';
import Image from 'next/image';
import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContentDocument } from '../types';

export function FirstPersonPerspectiveItem({
  props,
}: NodeProps<{
  author: PostAuthor;
  authorId: string;
  children: StructuredContentDocument;
}>): React.JSX.Element {
  const { author, children } = props;
  const authorMedia = author.featuredMedia;

  return (
    <FeatureViewed
      as="div"
      className="h-full w-full rounded-sm bg-accent"
      entitySection="banking"
      entityName="first-person-perspective-item"
    >
      <div className="grid gap-y-4 px-7 py-4 sm:grid-cols-12 sm:justify-center sm:gap-x-4 md:gap-x-0">
        <div className="pr-4 sm:col-span-9 md:col-span-10">
          <div className="border-l-4 border-[var(--content-green-lighter-2)] pl-4">
            <StructuredContentRenderer doc={children} />
          </div>
        </div>
        <div className="flex items-start gap-2 sm:col-span-2 sm:flex-col sm:items-center">
          {authorMedia?.croppedImage && (
            <div className="relative size-[60px] shrink-0 overflow-hidden rounded-full sm:size-[111px]">
              <Image
                alt={`${author.fullName}'s profile picture`}
                className="object-cover"
                fill
                src={authorMedia.croppedImage.sourceUrl}
              />
            </div>
          )}
          <span className="typography-body-small">{author.fullName}</span>
        </div>
      </div>
    </FeatureViewed>
  );
}
